export default __webpack_public_path__ + "static/media/Spotify_Logo_RGB_White.f48fb565.png";